"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullableIdValue = exports.isNumberAsStringValue = exports.isIDValue = void 0;
const primitives_1 = require("./primitives");
const typing_1 = require("./typing");
const isIDValue = (fieldValue) => typeof fieldValue === "string" || typeof fieldValue === "number";
exports.isIDValue = isIDValue;
/**
 * Checks if the provided value is a string that can be converted to a number
 * @example: isNumberAsStringValue("1") -> true
 * @example: isNumberAsStringValue("invalid string") -> false
 */
const isNumberAsStringValue = (fieldValue) => {
    if (!(0, primitives_1.isStringValue)(fieldValue))
        return false;
    return !isNaN(Number(fieldValue));
};
exports.isNumberAsStringValue = isNumberAsStringValue;
const isNullableIdValue = (fieldValue) => {
    return (0, typing_1.Union)(exports.isIDValue, primitives_1.isNullValue)(fieldValue);
};
exports.isNullableIdValue = isNullableIdValue;
